import React from "react";
import Plot from "react-plotly.js";

const Histogram = ({ plot, data, name }) => {
  const histplot = {
    x: data,
    type: plot,
    name: name,
  };

  return (
    <div>
      <Plot
        data={[histplot]}
        layout={{
          width:600,
          height:400,
          bargap: 0.05,
          bargroupgap: 0.2,
          barmode: "overlay",
          title: "Histogram Plot",
          xaxis: { title: "Value" },
          yaxis: { title: "Count" },
        }}
      />
    </div>
  );
};
export default Histogram;
